import { CIcon } from '~/icons/types'

export const ciTractors: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.943 12.17c.957 0 1.886.32 2.64.91a3.725 3.725 0 0 0-3.72-3.65h-.25V7.34c.004-.275.088-.542.24-.77l.23-.33a.485.485 0 0 0-.12-.68.5.5 0 0 0-.69.12l-.23.34a2.3 2.3 0 0 0-.41 1.33v2.08H14.4l-1.22-4.52h1.71a.49.49 0 0 0 0-.98H4.083a.49.49 0 1 0 0 .98h.78l-.77 3.53a7.36 7.36 0 0 0-3.36 1.78.48.48 0 0 0-.02.69.482.482 0 0 0 .69.03 6.256 6.256 0 0 1 6.678-1.224 6.122 6.122 0 0 1 3.752 5.784c0 .403-.04.805-.12 1.2a.52.52 0 0 0 .11.41.485.485 0 0 0 .38.17l3.55.05a3.598 3.598 0 0 1-.09-.88 4.277 4.277 0 0 1 4.28-4.28Zm-8.09-.54A7.274 7.274 0 0 0 5.7 8.25c-.194 0-.387.01-.58.03l.74-3.37h6.3l1.81 6.72h-2.117Z'
    },
    {
      d:
        'M19.943 13.09a3.485 3.485 0 1 0 3.216 2.148 3.476 3.476 0 0 0-3.216-2.148Zm0 4.78a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6Zm-14.26-7.69a4.945 4.945 0 1 0 4.95 4.95 4.953 4.953 0 0 0-4.95-4.95Zm0 6.96a2.01 2.01 0 1 1 2.01-2.01 2.017 2.017 0 0 1-2.01 2.01Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'tractors',
  type: 'solid'
}
